import Enum from "./Enum";

export default Enum.create( {
	ATTENDEE: "ATTENDEE",
	ORGANIZER: "ORGANIZER",
} );
